import React, { Component } from 'react';
import './A4.css';

class A4 extends Component{
    render(){
        return(    
        <div className="campoA4"style={{
            backgroundImage: 'url(' + require('../../../assets/texturas/gif-dimen-fr.gif') + ')'}}>{this.props.children}
        </div>
        )
    }

}

export default A4;